export default __webpack_public_path__ + "static/media/black beret.bbe863fd.png";